<template>
    <MainContainer>
        <template v-slot:sidebar>&nbsp;</template>
        <div class="abrechnung-gast">
            <section>
                <h2>Abrechnung Gastsänger</h2>
                <b-form>
                    <b-form-group label="Werk" label-for="werk" :label-size="size">
                        <b-select
                            id="werk"
                            :size="size"
                            :options="werke.options"
                            v-model="filter.werke"
                            :disabled="werke.busy"
                        ></b-select>
                    </b-form-group>
                    <b-button
                        :size="size"
                        @click="selectFilter"
                        :disabled="!validFilter"
                        variant="primary"
                    >Anzeigen</b-button>
                    <b-button
                        :size="size"
                        @click="download"
                        :disabled="true || !validFilter || busyPrinting"
                        class="ml-1"
                        variant="outline-primary"
                    >
                        <template v-if="busyPrinting">
                            <Spinner small variant="primary" class="mr-1" />
                        </template>
                        <template v-else>
                            <font-awesome-icon icon="print" class="mr-1" />
                        </template>Drucken
                    </b-button>
                    <b-dropdown
                        split
                        :size="size"
                        @click="downloadContracts"
                        :disabled="!validFilter || busyPrinting"
                        class="ml-1"
                        variant="outline-primary"
                    >
                        <template v-slot:button-content>
                            <template v-if="busyPrinting">
                                <Spinner small variant="primary" class="mr-1" />
                            </template>
                            <template v-else>
                                <font-awesome-icon icon="file-contract" class="mr-1" />
                            </template>Verträge ausgeben
                        </template>

                        <b-dropdown-item @click="editTemplate">Vertrag anpassen</b-dropdown-item>
                        <b-dropdown-divider />
                        <b-dropdown-text>Die textlichen Bausteine von Verträgen können hier angepasst werden</b-dropdown-text>
                    </b-dropdown>
                </b-form>
            </section>
            <hr />
            <section v-if="items.length > 0">
                <article>
                    <Table
                        bordered
                        striped
                        showFilter
                        :responsive="true"
                        :fields="fields"
                        :items="items"
                        :isBusy="busy"
                        busyText="Lädt Abrechnungsliste..."
                        emptyText="Keine Abrechnungsdaten gefunden"
                    >
                        <template v-slot:mitglied="{row: row}">
                            {{row.value}}
                            <br />
                            <b-button
                                variant="outline-primary"
                                @click="downloadContract(row.item.id)"
                            >
                                <font-awesome-icon icon="file-contract" class="mr-1" />Vertrag
                            </b-button>
                        </template>
                        <template v-slot:dates="{row: row}">
                            <b-table
                                class="inner-table"
                                :fields="row.value.fields"
                                :items="row.value.items"
                                small
                                :hover="false"
                                sort-by="pk_sort"
                            >
                                <template v-slot:head()="row">
                                    <template v-if="row.field.key !== 'pk_typ'">
                                        <small>{{$moment(row.label).format("DD.MM.Y")}}</small>
                                    </template>
                                    <template v-else>
                                        <small>{{row.label}}</small>
                                    </template>
                                </template>

                                <template v-slot:cell()="row">
                                    <template v-if="row.field.key !== 'pk_typ'">
                                        <template v-if="row.value === true">
                                            <font-awesome-icon icon="check" class="text-success" />
                                        </template>
                                        <template v-else-if="row.value === false">
                                            <font-awesome-icon icon="times" class="text-danger" />
                                        </template>
                                        <template v-else>&nbsp;</template>
                                    </template>
                                    <template v-else>{{row.value}}</template>
                                </template>
                            </b-table>
                        </template>

                        <template v-slot:benefits="{row: row}">
                            <b-table
                                class="inner-table"
                                :fields="row.value.fields"
                                :items="row.value.items"
                                small
                                :hover="false"
                            >
                                <template v-slot:head()="row">
                                    <small>{{row.label}}</small>
                                </template>
                                <template v-slot:cell(benefit)="row">
                                    <template v-if="row.value === '' || row.value === null">-</template>
                                    <template v-else>{{currency(row.value)}}</template>
                                </template>

                                <template v-slot:cell(sum)="row">{{currency(row.value)}}</template>

                                <template v-slot:custom-foot>
                                    <b-tr>
                                        <b-th colspan="2">
                                            <small>
                                                Probe: {{currency(row.value.total.proben)}}
                                                <br />
                                                Konzerte: {{currency(row.value.total.konzerte)}}
                                            </small>
                                        </b-th>
                                        <b-th class="text-right">{{currency(row.value.total.total)}}</b-th>
                                    </b-tr>
                                </template>
                            </b-table>
                        </template>
                    </Table>
                </article>
            </section>
            <section v-else>
                <template v-if="busy">
                    <CenteredMessage :spinner="true">
                        <template #title>Daten werden geladen</template>
                    </CenteredMessage>
                </template>
                <template v-else>
                    <CenteredMessage>
                        <template #title>Keine Daten vorhanden</template>
                        <template>
                            Bitte zuerst entsprechende Filter
                            auswählen
                        </template>
                    </CenteredMessage>
                </template>
            </section>
        </div>
        <TemplateDialog label="guestsinger_contract" />
    </MainContainer>
</template>

<script>
import Size from "@/mixins/Size/Size";
import Currency from "@/mixins/Currency/Currency";
import { ApiFactory } from "@/api/ApiFactory.js";
import { BlobUtil } from "@/utils/BlobUtil";
import MainContainer from "@/components/MainContainer/MainContainer";
import Table from "@/components/Table/Table";
import CenteredMessage from "@/components/CenteredMessage/CenteredMessage";
import Spinner from "@/components/Spinner/Spinner";
import TemplateDialog from "@/components/TemplateDialog/TemplateDialog";

import "./AbrechnungGast.scss";

const AbrechnungGastApi = ApiFactory.get("abrechnung_gast");
const WerkeApi = ApiFactory.get("werke");

export default {
    name: "AbrechnungGast",
    mixins: [Size, Currency],
    components: {
        MainContainer,
        Table,
        CenteredMessage,
        Spinner,
        TemplateDialog
    },
    data() {
        return {
            filter: {
                werke: null
            },
            fields: [
                {
                    key: "id",
                    label: "ID",
                    sortable: true
                },
                {
                    key: "mitglied",
                    label: "Mitglied",
                    sortable: true,
                    stickyColumn: true,
                    class: "table-light b-table-sticky-column"
                },
                {
                    key: "dates",
                    label: "Termine",
                    tdClass: "p-0"
                },
                {
                    key: "benefits",
                    label: "Vergütung",
                    tdClass: "p-0"
                }
            ],
            werke: {
                busy: false,
                options: [
                    {
                        value: null,
                        text: "Werk auswählen..."
                    }
                ]
            },
            items: [],
            busy: false,
            busyPrinting: false
        };
    },
    computed: {
        storedFilter() {
            const pages = this.$store.getters.getPages;
            if (pages.abrechnung_gast) {
                return pages.abrechnung_gast.filter;
            } else {
                return this.filter;
            }
        },
        validFilter() {
            return this.filter.werke !== null;
        }
    },
    async created() {
        this.filter = { ...this.storedFilter };
        await this.fetchWerke();
    },
    methods: {
        async fetch() {
            this.busy = true;
            if (this.validFilter) {
                const response = await AbrechnungGastApi.get(this.filter.werke);
                if (response.ok) {
                    if (response.json.collection) {
                        const collection = response.json.collection.map(
                            item => {
                                const availableDates = item.probenplan.map(
                                    termin => {
                                        const available = item.mitglied.anwesenheit.filter(
                                            anwesenheit =>
                                                anwesenheit.termin_id ===
                                                termin.id
                                        );
                                        termin.available = available.length > 0;
                                        return termin;
                                    }
                                );

                                const groupedBenefits = this.groupBy(
                                    "pk_typ",
                                    item.benefit
                                );

                                const groupedDates = this.groupBy(
                                    "pk_typ",
                                    availableDates
                                );

                                var dates = {
                                    fields: [
                                        {
                                            key: "pk_typ",
                                            label: "Probentyp"
                                        }
                                    ],
                                    items: []
                                };
                                var benefits = {
                                    fields: [
                                        {
                                            key: "active",
                                            label: "Anzahl",
                                            class: "text-center"
                                        },
                                        {
                                            key: "benefit",
                                            label: "Betrag",
                                            class: "text-right text-secondary"
                                        },
                                        {
                                            key: "sum",
                                            label: "Summe",
                                            class: "text-right"
                                        }
                                    ],
                                    items: [],
                                    total: {
                                        total: 0,
                                        proben: 0,
                                        konzerte: 0
                                    }
                                };

                                for (const key in groupedDates) {
                                    const groupedDate = groupedDates[key];
                                    var resultsData = {
                                        pk_typ: groupedDate[0].pk_bezeichnung,
                                        pk_sort: groupedDate[0].pk_sort
                                    };

                                    var active = 0;
                                    for (const date of groupedDate) {
                                        if (date.available) {
                                            active += 1;
                                        }
                                        dates.fields.push({
                                            key: String(date.id),
                                            label: date.datum,
                                            class: "text-center"
                                        });
                                        resultsData[date.id] = date.available;
                                    }

                                    var amount = 0;
                                    const currentBenefit =
                                        groupedBenefits[key][0].betrag;
                                    if (currentBenefit) {
                                        amount =
                                            active * Number(currentBenefit);
                                        benefits.total.total += amount;
                                        if (groupedDate[0].pk_klasse === 1) {
                                            benefits.total.proben += amount;
                                        } else {
                                            benefits.total.konzerte += amount;
                                        }
                                    }
                                    const resultsBenefits = {
                                        active: active,
                                        benefit: currentBenefit,
                                        sum: amount
                                    };

                                    dates.items.push(resultsData);
                                    benefits.items.push(resultsBenefits);
                                }

                                return {
                                    id: item.mitglied.id,
                                    mitglied:
                                        item.mitglied.vorname +
                                        " " +
                                        item.mitglied.name,
                                    status: item.mitglied.status,
                                    dates: dates,
                                    benefits: benefits
                                };
                            }
                        );
                        this.items = collection;
                    }
                }
            }
            this.busy = false;
        },
        async fetchWerke() {
            this.werke.busy = true;
            this.werke.options = [
                { value: null, text: "Werke werden geladen..." }
            ];
            this.filter.werke = null;

            const response = await WerkeApi.get();
            if (response.ok) {
                const data = response.json.collection;

                var options = [{ value: null, text: "Werk auswählen..." }];
                options = options.concat(
                    data.map(item => {
                        return {
                            value: item.id,
                            text:
                                item.bezeichnung +
                                " - " +
                                this.$moment(item.verfallsdatum)
                                    .subtract("1", "day")
                                    .format("DD.MM.Y")
                        };
                    })
                );
                this.werke.options = options;

                if (this.storedFilter.werke) {
                    this.filter.werke = this.storedFilter.werke;
                }
            }
            this.werke.busy = false;
        },
        selectFilter() {
            const filter = { ...this.filter };
            this.$store.dispatch("pages", {
                abrechnung_gast: {
                    filter: filter
                }
            });
            this.fetch();
        },
        async download() {
            this.busyPrinting = true;
            const response = await AnwesenheitsverwaltungApi.print(
                this.filter.werke,
                this.filter.singer
            );
            if (response.ok) {
                BlobUtil.downloadBlob(response.blob, "Anwesenheitsliste.pdf");
            }
            this.busyPrinting = false;
        },
        async downloadContract(id) {
            this.busyPrinting = true;
            const response = await AbrechnungGastApi.contract(
                this.filter.werke,
                id
            );
            if (response.ok) {
                BlobUtil.downloadBlob(
                    response.blob,
                    "Gastsaengervertraege.pdf"
                );
            }
            this.busyPrinting = false;
        },
        async downloadContracts() {
            this.busyPrinting = true;
            const response = await AbrechnungGastApi.contracts(
                this.filter.werke
            );
            if (response.ok) {
                BlobUtil.downloadBlob(
                    response.blob,
                    "Gastsaengervertraege.pdf"
                );
            }
            this.busyPrinting = false;
        },
        editTemplate() {
            this.$root.$emit("bv::show::modal", "templateDialog");
        },
        groupBy(key, array) {
            return array.reduce((objectsByKeyValue, obj) => {
                const value = obj[key];
                objectsByKeyValue[value] = (
                    objectsByKeyValue[value] || []
                ).concat(obj);
                return objectsByKeyValue;
            }, {});
        }
    }
};
</script>
